import { useChannels } from "api/channels";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
}

export const Channels = memo(({ index, size, onChange }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const isInlineType = size === "inline";
  const { useChannelList } = useChannels();
  const { data: channelList } = useChannelList();
  const channelsLabels =
    channelList?.items?.map(({ channelId, name }) => ({
      label: name,
      id: channelId,
    })) || [];

  return (
    <SelectInput
      name={`filters.${index}.value`}
      displaySearch
      data-test-id="filter-value"
      width="100%"
      items={channelsLabels}
      size={isInlineType ? "small" : size}
      onChange={onChange}
      placeholder={message({ id: "value" })}
      adjustWidthToValue={isInlineType}
      className={isInlineType ? classes.inlineValue : ""}
      keepDetailedValue
      validateOnChange
    />
  );
});
